const template = document.createElement("template");

template.innerHTML = /* HTML */ ``;

export class Logora extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: "open" });
    this.shadowRoot!.appendChild(template.content.cloneNode(true));
  }

  #dialog: HTMLDialogElement | null = null;

  #handleAuthRequest = (): void => {
    this.#dialog?.querySelectorAll("ws-link").forEach((link) => {
      const href = link.getAttribute("href");
      if (href?.includes("wdycf=")) {
        const updated = href.replace(
          /wdycf=[^&]*/,
          `wdycf=${encodeURIComponent(window.location.href)}`,
        );
        link.setAttribute("href", updated);
      }
    });
    window.dataLayer.push({
      event: "logora_barrier_shown",
      content: {
        shortname: window.logora_config?.shortname || null,
        url: window.location.href,
        type: "logora_debate",
      },
    });
    this.#dialog?.showModal();
  };

  async fetchLogoraJWT(): Promise<string | null> {
    const local = localStorage.getItem("logora-key");
    if (local) {
      try {
        const parsed = JSON.parse(local);
        const expire = new Date(parsed.expire).getTime();
        if (expire > Date.now()) {
          return parsed.token;
        }
      } catch {
        localStorage.removeItem("logora-key");
      }
    }

    try {
      const response = await fetch(`/p-api/logora/jwt`);
      if (!response.ok) return null;

      const json = await response.json();
      localStorage.setItem("logora-key", JSON.stringify(json));
      return json.token;
    } catch {
      return null;
    }
  }

  async connectedCallback() {
    this.#dialog = this.parentElement?.querySelector(
      "#logora-dialog",
    ) as HTMLDialogElement | null;

    window.addEventListener(
      "logora:authentication:requested",
      this.#handleAuthRequest,
    );

    const shortname = this.getAttribute("shortname");
    const isLoggedIn = document
      .querySelector("ws-user")
      ?.hasAttribute("logged-in")
      ? true
      : false;
    let remote_auth = "";

    if (!isLoggedIn) {
      localStorage.removeItem("logora-key");
    } else {
      const jwt = await this.fetchLogoraJWT();
      remote_auth = jwt ?? "";
    }

    (window as any).logora_config = {
      shortname,
      remote_auth,
    };

    // Load the script into the main document
    const script = document.createElement("script");
    script.src = "https://cdn.logora.com/debat.js";
    script.async = true;
    script.fetchPriority = "high";
    document.body.appendChild(script);
  }

  disconnectedCallback(): void {
    window.removeEventListener(
      "logora:authentication:requested",
      this.#handleAuthRequest,
    );
  }
}

"customElements" in window &&
  customElements.get("ws-logora") === undefined &&
  customElements.define("ws-logora", Logora);

declare global {
  // eslint-disable-next-line @typescript-eslint/consistent-type-definitions
  interface HTMLElementTagNameMap {
    "ws-logora": Logora;
  }
}
